<template>
  <div :class="['form-group', tableCheckData ? 'mb-0' : '']">
    <div
      :class="['d-flex', 'custom-control', 'custom-checkbox', tableCheckData ? 'justify-content-center' : '']"
      style="padding-left: 0.5rem"
    >
      <input
        type="checkbox"
        :name="formName"
        :id="formName"
        class="my-0 custom-control-input"
        :checked="inputValue"
        :disabled="disabled"
        @change="$emit('cg-input', $event.target.checked)"
      />
      <label class="teal my-0 ml-3 custom-control-label" :for="formName">{{ label }}</label>
    </div>
    <span v-if="info" class="text-primary" v-html="info"></span>
  </div>
</template>

<script>
export default {
  props: ['label', 'formName', 'value', 'disabled', 'info', 'tableCheck'],
  emits: ['cg-input'],
  inheritAttrs: false,
  data() {
    return {
      inputValue: (this.value ?? false) === '0' ? false : !!(this.value ?? false),
      tableCheckData: this.tableCheck ?? false,
    };
  },
};
</script>
